module.exports = __webpack_public_path__ + "static/media/gstreak.fce59ba8.png";